import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from "../../../../services/authentication.service";
import { I9Service } from 'src/app/services/i9-service';
import { ReferenceLibrary } from '../../../../data/models/referenceLibrary.model';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-i9-beneficiary-landing',
  templateUrl: './i9-beneficiary-landing.component.html',
  styleUrls: ['./i9-beneficiary-landing.component.scss']
})
export class I9BeneficiaryLandingComponent implements OnInit {

  formsList:any[] = [];
  totalElementCount: number = 0;
  pageSizeOptions = [10, 20, 30];
  pageIndex: number = 0;//default
  pageSize: number = 1;//default
  payload = {
    "pageNumber": this.pageIndex,
    "recordsPerPage": this.pageSize
  };
  beneficiaryId;
  colList: any[];
  formTypeList: ReferenceLibrary[];
  selectedFormType: any;
  pdfSrc = null;
  displayDialog:boolean = false;
  showLoader:boolean = false;
  
  constructor(private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private referenceLibraryService: ReferenceLibraryService,
    private I9Service: I9Service,
    private router: Router,) {
      this.referenceLibraryService.getReferenceData('MYFORMS').subscribe((data: ReferenceLibrary[]) => {
        this.formTypeList = data;
        this.selectedFormType = this.formTypeList[0];
        this.getI9BeneficiaryForms();
      });
  }

  ngOnInit() {
    this.beneficiaryId = sessionStorage.getItem("listBeneficiaryId")
      ? parseInt(sessionStorage.getItem("listBeneficiaryId"))
      : parseInt(this.authenticationService.currentUserValue["beneficiaryId"]);
    this.colList = [
      { field: 'formName', header: 'Form Name' },
      { field: 'companyName', header: 'Company Name' },
      { field: 'createdBy', header: 'Created By' },
      { field: 'status', header: 'Status' }
    ]; 
  }

  ngAfterViewInit() {
    this.translet();
  }

  translet() {
    setTimeout(() => {
      this.referenceLibraryService.transletConversion();
    }, 600);
  }

  updateFormTypeList(){
    this.getI9BeneficiaryForms();
  }

  getI9BeneficiaryForms(){
    this.I9Service.getBeneficiaryFormList(this.selectedFormType['code'],this.beneficiaryId,this.payload).subscribe((response) => {
      if (response) {
        this.formsList = response['i9FormList'];
      }
    });
  }

  handleEdit(task){
    let isEdit = 0;
    if(task.statusCode === 'INITIATED' || task.statusCode === 'SENTBACK'){
      isEdit = 1;
    }else{
      isEdit = 0;
    }
    let queryParamsObj = { 
      beneficiaryId: task.beneficiaryId || 0, 
      companyId: task.companyId || 0, 
      i9FormId: task.i9FormId || 0,
      edit: isEdit
    }
    this.router.navigate(['../forms/edit-form'], { queryParams:  queryParamsObj, relativeTo: this.route });
  }

  handleView(task){
    this.pdfSrc = environment.docs + task.i9FormPath;
    this.displayDialog = true;
  }

  paginationEvent(event) {  
    this.payload.pageNumber = event.page + 1;
    this.payload.recordsPerPage = event.rows;
    this.getI9BeneficiaryForms();
  }

  onProgress(progressData) {
    this.showLoader = true;
  }

  onComplete(i){
    this.showLoader = false;
  }

}
